import React, { useContext, useEffect, useState } from 'react';
import { Container, Row, Col, Card, Accordion, ListGroup, Image} from 'react-bootstrap';
import { BsQrCode } from 'react-icons/bs';
import { OrderContext } from '../../context/OrderContext';
import './missing-styles.css'
import { MdOutlineContactSupport } from "react-icons/md";
import { RiShoppingBasketLine } from "react-icons/ri";
import useCreateRefund from '../../hook/useCreateRefund';
import { IoLocationSharp } from "react-icons/io5";




const MissingProductSummary = () => {

  const { missingProduct, orderNumber, shippingAdress } = useContext(OrderContext);
  const {dataProducts} = useCreateRefund()

  const map_product = missingProduct?.SubjectOrderProducts

  // console.log("map_product", map_product)


  const totalProducts = map_product?.reduce((acc, item) => acc + item.Count, 0);
  const totalAmount = map_product?.reduce((acc, item) => acc + (item.BasePrice * item.Count), 0);
  
      

  function formatCurrency(amount) {
    return new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY' }).format(amount);
  }


 
  return (
    <Container className="d-flex flex-column justify-content-center align-items-center" style={{ minHeight: '100vh' }} fluid> 
    <Card className='summary-card-return' >
      <Row style={{ minHeight: '100%' }}>
        <Col md={6} className="d-flex flex-column justify-content-center">
          <Card className='card-qr' style={{ minHeight: '100%' }}>
          <Card.Text className="text-left mt-3 ms-3">Sipariş Numarası : <span>#{orderNumber}</span></Card.Text>
            <Card.Body className='text-center aligin-items-center'>
              <Card.Text className="text-left mt-3" style={{fontWeight:'bold'}}>
                Talebiniz alınmıştır.
              </Card.Text>
              <Card.Text className="text-comment">
              <span>#{orderNumber}</span> numaralı siparişiz ile ilgili "eksik ürün" talebinizi aldık. Siparişinizle ilgili gelişmeleri size e-posta yolu ile ileteceğiz.
              </Card.Text>

              <Card.Text className="text-icon">
                    <IoLocationSharp  size={24}/>

                   Teslimat Adresi

              </Card.Text>

              <Card.Text className="text-address">
                    {shippingAdress?.AddressText}
                    <span style={{fontWeight:'normal', color:'#637386', marginLeft:'3px'}}>{shippingAdress?.City}</span>
              </Card.Text>

            </Card.Body>
            <Card.Footer className="text-muted">
            <MdOutlineContactSupport size={24}/>
          <span>support@kolay.iade.com</span>
           </Card.Footer>
          </Card>
        </Col>

        <Col md={6}>
          <h4 className='h4-title' style={{marginTop:'15px'}}>Eksik Ürün Özeti</h4>
                <ListGroup>
                  {map_product?.map((product) => (
                    <ListGroup.Item 
                      key={product.Id} 
                      // onClick={() => handleShowModal(product)}
                      className='list-summary'
                    >
                      <Row className="g-1 align-items-center row_box">
                        <Col xs={4} md={4} l={4} className="product-image-col">
                          <Image src={product.image} alt={product.Name} className="product-image-summary" />
                        </Col>
                        <Col xs={8} md={8} l={8} className="product-info">
                          <h5 className="product-title">{product.Name}</h5>
                          <p className="product-size-color">Adet: {product.Count}</p>
                          <p className="product-size-color-price">Fiyat: {formatCurrency(product.BasePrice)}</p>
                        </Col>
                      </Row>
                    </ListGroup.Item>
                  ))}
                </ListGroup> 
                <Row className="g-1 align-items-center row_box mt-3">
                <Row >
                  <Col xs={6} md={6} className="summary-title">
                    Ürün Adedi:
                  </Col>
                  <Col xs={6} md={6} className="summary-value">
                    {totalProducts}
                  </Col>
                </Row>
                <Row>
                  <Col xs={6} md={6} className="summary-title">
                    İade Tutarı:
                  </Col>
                  <Col xs={6} md={6} className="summary-value">
                    {formatCurrency(totalAmount)}
                  </Col>
                </Row> 
                </Row>  
             </Col>
        </Row>
      </Card>
      
    </Container>
  );
};

export default MissingProductSummary;
